import { useEffect, useRef } from 'react'
import { GridElement } from '..'
import { generateIdForHeading } from '../../utilities'
import React from 'react'

import './rich-text.scss'

export const RichText: React.FC<GridElement> = props => {
    const ref = useRef<HTMLDivElement>(null)

    useEffect(() => {
        if (!ref) return

        const h2s = ref?.current?.querySelectorAll('h2')

        h2s.forEach(h2 => {
            h2.id = generateIdForHeading(h2.innerText)
        })
    }, [ref])

    return <div className="rich-text" ref={ref} dangerouslySetInnerHTML={{ __html: props.value }} />
}
